import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-apropos',
  templateUrl: './apropos.component.html',
  styleUrls: ['./apropos.component.css']
})
export class AproposComponent implements OnInit {
  private myDescription: string;

  constructor() { }

  ngOnInit() {
    console.log("Apropos page");
  }

}



// WEBPACK FOOTER //
// C:/Users/Yassine/Desktop/gestion-stagiaires/src/app/apropos/apropos.component.ts